import { baseurl, get, LogErrorMessage } from '../service';

/**
 * Response from GET /SelfService/GetStripeData
 * @typedef {Object} StripeDataResponse
 * @property {string} publishableKey - Stripe publishable key (pk_test_... or pk_live_...)
 * @property {string|null} secretKey - Stripe secret key (always null in response for security)
 * @property {string} isStripeEnabled - String boolean indicating if Stripe is enabled ("true" or "false")
 */

/**
 * Get Stripe configuration data from the backend
 * @returns {Promise<StripeDataResponse|null>} Stripe configuration or null if error
 */
export const getStripeData = async () => {
  try {
    const url = `${baseurl()}/SelfService/GetStripeData`;

    /** @type {StripeDataResponse} */
    const response = await get(url);

    // Validate response structure
    if (response && typeof response.isStripeEnabled === 'string') {
      return {
        publishableKey: response.publishableKey || '',
        secretKey: response.secretKey || null,
        isStripeEnabled: response.isStripeEnabled,
      };
    }

    console.error('getStripeData: Invalid response format', response);
    return null;
  } catch (error) {
    console.error('Failed to get Stripe data:', error);
    LogErrorMessage(error);
    return null;
  }
};
